import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20with%20flowing%20digital%20network%20lines%20and%20soft%20glowing%20nodes%2C%20minimalist%20geometric%20composition%2C%20terracotta%20and%20golden%20amber%20tones%2C%20elegant%20technology%20abstract%20background%2C%20cinematic%20lighting%2C%20depth%20of%20field%2C%20no%20text%2C%20no%20human%20faces&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 via-primary-500/85 to-primary-600/90"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-white mb-4">
          准备好开始搜索了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-[480px] mx-auto leading-relaxed">
          输入关键词，即刻发现海量优质资源。完全免费，无需注册。
        </p>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-xl hover:bg-white/95 transition-all whitespace-nowrap"
        >
          <i className="ri-search-line"></i>
          立即开始搜索
        </Link>
      </div>
    </section>
  );
}